import { FC } from 'react';
import { withHeader } from '../../HOC/withHeader';
import FontCreatorContainer from '../../modules/fontCreator/FontCreatorContainer';

const FontCreatorPageContainer: FC = withHeader(FontCreatorContainer);

export default FontCreatorPageContainer;
